import Badge from "../../../../ui/Badge/Badge";
import styles from "./ArticleHeader.module.scss";
import ArticleImage, {
  ArticleImageImageFragment,
} from "../ArticleImage/ArticleImage";
import {
  FragmentType,
  getFragmentData,
  graphql,
} from "../../../../__generated__/gql";
import { useMutation } from "urql";
import { useCallback } from "react";

const UpdateArticleHeroImageMutation = graphql(/* GraphQL */ `
  mutation updateArticleHeroImage($articleId: String!, $id: String!) {
    updateArticle(input: { id: $articleId, heroImage: { id: $id } }) {
      heroImage {
        ...ArticleImage
      }
    }
  }
`);

function ArticleHeader({
  articleId,
  tag,
  data,
}: {
  articleId: string;
  tag?: string | null;
  metaDescription: string;
  data?: FragmentType<typeof ArticleImageImageFragment> | null;
}) {
  const image = getFragmentData(ArticleImageImageFragment, data);

  const [updateArticleHeroImageResponse, updateArticleHeroImage] = useMutation(
    UpdateArticleHeroImageMutation,
  );

  const setImage = useCallback(
    async ({ id }: { id: string }) => {
      if (id === image?.id) {
        return;
      }

      await updateArticleHeroImage({
        articleId,
        id,
      });
    },
    [articleId, image?.id, updateArticleHeroImage],
  );
  const updatedImageFragment = getFragmentData(
    ArticleImageImageFragment,
    updateArticleHeroImageResponse.data?.updateArticle.heroImage,
  );

  return (
    <div>
      <ArticleImage
        className={styles.heroImage}
        id={
          !updateArticleHeroImageResponse.fetching
            ? (updatedImageFragment?.id ?? image?.id)
            : undefined
        }
        data={
          !updateArticleHeroImageResponse.fetching
            ? (updateArticleHeroImageResponse.data?.updateArticle.heroImage ??
              data ??
              undefined)
            : undefined
        }
        setImage={setImage}
      />
      <div className={styles.textContent}>
        {tag && (
          <Badge
            showDot={false}
            variant="badge"
            size="medium"
            color="default"
            className={styles.tag}
          >
            {tag}
          </Badge>
        )}
      </div>
    </div>
  );
}

export default ArticleHeader;
